export function buildAppState(
  href: string,
  incomingEntries: Record<string, string>,
) {
  const u = new URL(href);
  return {
    source: 'ot-login' as const,
    returnTo: u.pathname + u.search,
    incoming: incomingEntries,
  } as const;
}
